import { t } from "i18next";
import CalendarScheduleModel from "../../../models/CalendarScheduleModel";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import AppButton from "../../buttons/AppButton";
import CenteredModal from "../CenteredModal";

type ReviewScheduleModalProps = {
  schedule: CalendarScheduleModel | null;
  setOpen: (newState: boolean) => void;
  onSubmit: () => void;
  open: boolean;
};

const TIME_FORMAT = "hh:mm A";
export default function ReviewScheduleModal(props: ReviewScheduleModalProps) {
  const { open, setOpen, schedule, onSubmit } = props;
  const localeBase = "page.liaison.dashboard.schedule.reviewScheduleModal";

  const scheduleMap = !!schedule ? schedule.generateScheduledSlotsMap() : {};
  const renderDaySlots = (slots: CalendarScheduleSlotModel[]) => {
    return slots.map((slot: CalendarScheduleSlotModel) => {
      return (
        <p className="text-base font-normal text-brandblue-600 mt-1">{`${slot.startTime.format(
          TIME_FORMAT
        )} - ${slot.endTime.format(TIME_FORMAT)}`}</p>
      );
    });
  };
  return (
    <CenteredModal open={open} setOpen={setOpen}>
      <div className="w-[32rem] max-w-full">
        <h1 className="text-lg font-medium">{t(`${localeBase}.title`)}</h1>
        {Object.keys(scheduleMap).map((dayOfWeek: string) => {
          return (
            <div className="mt-2">
              <h3 className="text-base font-normal">
                {t(`weekdays.${dayOfWeek}`)}
              </h3>
              {renderDaySlots(scheduleMap[dayOfWeek])}
            </div>
          );
        })}
        <div className="mt-5 sm:mt-6">
          <AppButton
            cypressSelector={"confirm"}
            onClick={onSubmit}
            buttonShape="primary"
            className="w-full"
          >
            {t(`${localeBase}.confirm`)}
          </AppButton>
          <AppButton
            cypressSelector={"undoScheduling"}
            onClick={() => setOpen(false)}
            buttonShape="secondary"
            className="w-full mt-2"
          >
            {t(`${localeBase}.cancel`)}
          </AppButton>
        </div>
      </div>
    </CenteredModal>
  );
}
